import * as React from 'react';
import Split from 'react-split';
import styled from 'styled-components';

import { getHeight } from '@process-advisor/process-miner/shared/theme';
import { defaultSidebarWidth, minDiagramWidth, minSidebarWidth } from '@process-advisor/process-miner/components/slidingPanel/consts';
import SlidingPanelIcon from "@process-advisor/assets/slidingPanelIcon.png"

const Wrapper = styled.div`
  height: 100%;
  min-height: 0;
`;

type Props = {
    onDragEnd: (sizes: number[]) => void,
    max: string,
    width: any,
    mode: any,
}

const StyledSplit = styled(Split)`
display: flex;
flex-direction: row;
justify-content: space-between;
width: 100%;
height: 100%;
min-height: 0;

& .gutter {
    background-repeat: no-repeat;
    background-position: 50%;
    background-image: url(${SlidingPanelIcon});
    cursor: col-resize;
    position: relative;
    z-index: 20;
}
`   ;

export const SlidingPanel: React.FC<Props> = ({children, onDragEnd , max, width, mode}) => {    

    const [sideBarWidth, setSideBarWidth] = React.useState<number>();
    const [minDWidth, setMinDWidth] = React.useState<number>();
    const [minSBWidth, setminSBWidth] = React.useState<number>();
    const [activeSlidingPanelIcon,setActiveSlidingPanelIcon]  = React.useState<any>();

    React.useEffect(() => {
        setActiveSlidingPanelIcon(SlidingPanelIcon)
        setSideBarWidth(defaultSidebarWidth)
        setMinDWidth(minDiagramWidth)
        setminSBWidth(minSidebarWidth)

        if (max === 'true') {
            setActiveSlidingPanelIcon('')
            setSideBarWidth(0)
            setMinDWidth(0)
            setminSBWidth(0)
        }
    }, [max]);
   

    React.useEffect(() => {
        setActiveSlidingPanelIcon(SlidingPanelIcon)
        setSideBarWidth(width)
        setMinDWidth(minDiagramWidth)
        setminSBWidth(minSidebarWidth)
    }, [width]);


   return (
        <Wrapper>
        {mode === 'process_miner' ?
        <div style={{ height: '100%', minHeight: 0 }}>
            <StyledSplit
                gutterSize={10}
                sizes={[100 - sideBarWidth, sideBarWidth]}
                minSize={[minDWidth, minSBWidth]}
                expandToMin={false}
                gutterAlign="center"
                snapOffset={30}
                dragInterval={1}
                direction="horizontal"
                cursor="col-resize"
                onDragEnd={onDragEnd}
                max={max}
            >
                {children}
            </StyledSplit>
        </div>
        :
        <div style={{ height: '100%', minHeight: 0, width: '100%' }}>
            {React.Children.toArray(children)[0]}
        </div>
        }
        </Wrapper>
   )
};
